module.exports = __webpack_public_path__ + "static/media/award1.12f9981f.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_130/image/award1.png
// module id = 1180
// module chunks = 0